
/**
 * These types should all be renderable by the notification
 * html logic in native code for Android & iOS
 */
export const CapNotificationAllowedTags = ["B", "I", "P", "OL", "UL", "LI"] as const
